var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendReminder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 105,
    viewBox: "0 0 156 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1654_13784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.831 4.34961H54.6066C47.0239 4.34961 40.8596 10.4937 40.8596 18.0515C40.8596 25.1199 46.2602 30.9377 53.1337 31.6446V38.9305L60.8255 31.6989H108.831C116.414 31.6989 122.578 25.5549 122.578 17.9971C122.578 10.4393 116.414 4.34961 108.831 4.34961Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4062 14.627H107.03V15.7144H56.4062V14.627Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4062 20.3906H107.03V21.4781H56.4062V20.3906Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69 120.001L126.942 108.311L99.8845 112.607L59.0797 88.8458L63.8257 76.6664L36.659 58.941C33.2222 56.3855 32.3494 51.6007 34.6405 48.0121L35.8952 46.0547L85.9738 70.6854H117.068L152.909 87.1059L153.618 88.0302C165.074 107.713 143.69 120.001 143.69 120.001Z",
    fill: "#BEAAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.233 96.6189L123.724 95.6402C113.359 90.4205 105.558 81.5578 101.739 70.6289L100.703 71.0095C104.631 82.1559 112.595 91.2904 123.233 96.6189Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.504 91.0735L107.303 95.967C105.121 98.5225 101.685 99.6099 98.4661 98.7943C97.375 98.5225 96.3931 98.0331 95.4657 97.435L18.9841 42.7363C16.8566 41.2139 16.0929 38.3322 17.2385 35.9398C17.8931 34.6348 18.9841 33.6018 20.4025 33.1668L30.0036 29.8501C31.6947 29.252 33.4949 29.5238 34.9678 30.5569L110.631 84.005C112.977 85.6362 113.359 88.8986 111.504 91.0735Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.977 85.5267L33.1131 31.1543L21.2208 35.6128L103.048 93.6826L109.977 85.5267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3917 76.1758L74.9542 98.251L94.4838 108.527L96.3931 99.3384L89.5195 95.913L90.1196 88.8446C90.556 83.8967 88.374 79.1119 84.3917 76.1758Z",
    fill: "#BEAAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9898 66.9863L57.5524 89.0616L77.0819 99.3379L78.9912 90.149L72.1177 86.7235L72.7178 79.6551C73.1542 74.7072 70.9721 69.9224 66.9898 66.9863Z",
    fill: "#BEAAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1325 61.2779L53.4063 83.4075L68.7354 83.8425L57.2249 65.954C54.0064 62.2566 49.0422 60.4623 44.1325 61.2779Z",
    fill: "#BEAAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8088 84.9802L80.8184 85.3926L75.4396 98.4734L74.43 98.061L79.8088 84.9802Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4658 73.0056L64.4785 73.4102L60.237 83.9584L59.2243 83.5538L63.4658 73.0056Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.943 89.2247C118.487 86.8867 108.395 80.1989 101.794 70.6293L97.4844 64.3765L91.4837 63.0716C89.6835 67.0408 85.1011 68.8894 81.0097 67.3126L79.4823 66.7145L82.7008 51.4902H110.795L133.979 79.1114L129.943 89.2247Z",
    fill: "#BEAAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.053 29.0345C145.053 28.0558 145.872 27.2402 146.853 27.2402C147.835 27.2402 148.654 28.0558 148.654 29.0345C148.654 30.0132 147.835 30.8288 146.853 30.8288C145.872 30.8288 145.053 30.0132 145.053 29.0345ZM148.654 43.3345H146.853V37.9516H145.981V43.3345H144.18V37.9516V36.1573V33.4931H142.38V31.6988H147.781C148.763 31.6988 149.581 32.5144 149.581 33.4931V37.9516H148.708V43.3345H148.654ZM128.906 29.0345C128.906 28.0558 129.724 27.2402 130.706 27.2402C131.688 27.2402 132.506 28.0558 132.506 29.0345C132.506 30.0132 131.688 30.8288 130.706 30.8288C129.67 30.8288 128.906 30.0132 128.906 29.0345ZM129.779 31.6988H135.179V33.4931H133.379V36.1573V37.9516V43.3345H131.579V37.9516H130.706V43.3345H128.906V37.9516H128.033V33.4931C127.979 32.5144 128.797 31.6988 129.779 31.6988Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78 30.8288C137.786 30.8288 136.98 30.0255 136.98 29.0345C136.98 28.0436 137.786 27.2402 138.78 27.2402C139.774 27.2402 140.58 28.0436 140.58 29.0345C140.58 30.0255 139.774 30.8288 138.78 30.8288Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.453 33.4935V37.0821H140.58V43.3349H136.98V37.0821H136.107V33.4935C136.107 32.5148 136.925 31.6992 137.907 31.6992H139.707C140.635 31.6992 141.453 32.5148 141.453 33.4935Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4812 56.7104H77.5723C77.3541 45.6727 70.7533 34.2545 59.5156 25.4462C48.3871 16.6922 33.8218 11.3637 19.5837 10.7656L19.5292 11.8531C33.549 12.4512 47.8416 17.7253 58.8065 26.3161C69.8259 34.907 76.263 45.999 76.4812 56.7104Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7847 15.6052L28.9668 8.48242L17.6746 11.201L26.7847 15.6052ZM27.3302 10.0049L26.0756 14.0828L20.8386 11.5817L27.3302 10.0049Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9013 56.2748C100.811 47.5208 111.285 40.6699 122.305 36.9725L121.977 35.9395C110.794 39.6368 100.157 46.5965 92.1376 55.5135L92.9013 56.2748Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.359 42.6289L123.941 35.8867L112.322 36.3761L116.359 42.6289ZM120.941 37.0829L116.631 40.9434L114.286 37.3548L120.941 37.0829Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9539 25.3379H76.0449V28.7634H74.9539V25.3379Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8084 26.5352H77.2451V27.6226H73.8084V26.5352Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1712 41.4862H67.2622V47.6303H66.1712V41.4862Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6618 43.9882H69.8262V45.0756H63.6618V43.9882Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 18.8672H22.3662V22.2927H21.2752V18.8672Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1297 20.0098H23.5664V21.0973H20.1297V20.0098Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1321 0.216797H39.2231V6.36088H38.1321V0.216797Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5681 2.71875H41.7324V3.8062H35.5681V2.71875Z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2559 0V4.40417H11.783V2.93611H4.41846V1.46806H11.783V0H13.2559Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.43866e-05 6.63344V5.16538V1.46806H2.23654V0H3.70944V4.40417H2.23654V2.93611H1.47281V5.16538H14.7834V2.93611H14.0197V1.46806H16.2563V5.16538V6.63344V16.9642H-7.43866e-05V6.63344ZM11.7831 11.7988V13.2669H13.256V11.7988H11.7831ZM13.256 10.3308V8.86271H11.7831V10.3308H13.256ZM8.8373 11.7988V13.2669H10.3102V11.7988H8.8373ZM10.3102 10.3308V8.86271H8.8373V10.3308H10.3102ZM5.89151 11.7988V13.2669H7.36442V11.7988H5.89151ZM7.36442 10.3308V8.86271H5.89151V10.3308H7.36442ZM2.94572 11.7988V13.2669H4.41861V11.7988H2.94572ZM4.41861 10.3308V8.86271H2.94572V10.3308H4.41861Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1654_13784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 157 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendReminder);
export default __webpack_public_path__ + "static/media/send_reminder.e2f89c87efc50b069ae6a6076d631adb.svg";
export { ForwardRef as ReactComponent };